import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconArrowLeftOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m2.871 11.25 8.266-8.266a.75.75 0 1 0-1.06-1.06L0 12l10.076 10.076a.75.75 0 1 0 1.06-1.06L2.872 12.75H23.25a.75.75 0 0 0 0-1.5z" /></svg>
);
